import React, { FC, useState } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import FhirLoader from '../../FhirLoader'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { ContactInfoSchema } from '../../../utils/validation'
import Turnstile from 'react-turnstile'
import useEnvironment from '../../../hooks/location/useEnviroment'
import { renderFormikError } from '../../../utils/helpers'

type ContactInfoProps = {
  initialValues: any;
  isLoading: boolean;
  isError: boolean;
  error: string;
  onSubmit: (values: any) => void;
}

const ContactInfo: FC<ContactInfoProps> = ({
  initialValues,
  isLoading,
  onSubmit,
}) => {
  const [showError, setShowError] = useState(false)

  const { data: environmentData, isSuccess: isEnvironmentSuccess } = useEnvironment()

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      captcha: null,
    },
    validationSchema: ContactInfoSchema,
    onSubmit: (values) => {
      onSubmit(values)
    },
    enableReinitialize: true,
  })

  return (
    <>
      <p className="text-info">
        Please enter an email to use with the Member Portal. We will send a
        verification to continue with registration.
      </p>
      <Form noValidate onSubmit={formik.handleSubmit} className='formContainer'>
        <h4>Email</h4>
        <div>
          {showError && (
            <Alert
              variant="danger"
              dismissible
              onClose={() => setShowError(false)}
            >
              There was an error
            </Alert>
          )}
          <Form.Group>
            <Form.Label htmlFor="email" className="visually-hidden">Email</Form.Label>
            <Form.Control
              id='email'
              name="email"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={!!formik.errors.email && !!formik.touched.email}
              aria-invalid={!!formik.errors.email && !!formik.touched.email}
              aria-describedby={formik.errors.email && formik.touched.email ? 'email-error' : ''}
              aria-required="true"
            />
            <Form.Control.Feedback 
             id="email-error"
             type="invalid"
             role="alert"
              >

              {renderFormikError(formik.errors.email)}
            </Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='my-3'>
          {
            isEnvironmentSuccess && (
              <Turnstile
                sitekey={environmentData?.turnstileSiteKey || ''}
                onSuccess={(value) => formik.setFieldValue('captcha', value)}
                theme='light'
                aria-label="CAPTCHA: Please verify that you are not a robot"
              />
            )
          }
          {
            Boolean(!!formik.errors.captcha && formik.touched.captcha) && (
              <Form.Text className='text-danger'>
                {renderFormikError(formik.errors.captcha)}
              </Form.Text>
            )
          }
        </div>
        <Link to="/register/member" className="btn btn-light me-3">
          &lt;&lt; Back
        </Link>
        <Button variant='primary' type="submit">
          {isLoading ? (
            <FhirLoader small={true} />
          ) : (
            'Next >>'
          )}
        </Button>
      </Form>
    </>
  )
}

export default ContactInfo
